<div class="tabs">
  <div
    class="tab"
    *ngFor="let tab of tabs; let index = index"
    [class.active]="activeTab === index"
    (click)="selectTab(index)">
    {{ tab.label }}
  </div>
</div>
